module.exports = __webpack_public_path__ + "static/media/default-lab.ad74249a.png";